import { render, staticRenderFns } from "./dreamte.vue?vue&type=template&id=6f11d3f7&scoped=true&"
import script from "./dreamte.vue?vue&type=script&lang=js&"
export * from "./dreamte.vue?vue&type=script&lang=js&"
import style0 from "./dreamte.vue?vue&type=style&index=0&id=6f11d3f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f11d3f7",
  null
  
)

export default component.exports